module.exports = __webpack_public_path__ + "media/images/openweather/mapicons/br-4daf314169227a1fd143486c5959e246.png";